
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ButtonCustom from "../../../../../../Components/ButtonCustom"
import { Card, ContainerCards, ContainerTags } from "../../styled"
import { faEye } from "@fortawesome/free-solid-svg-icons"
import { LineDivider } from "../../../../../../Components/CustomUi/LineDivider"
import { Empty, Tag } from "antd"
import { corDoModulo } from "../meta"

interface CardsDadosConsultoriaProps {
    dados_consultoria: any[]
    buscar_consultoria: string
    abrir_gaveta: Function
    modulos: any[]
}

export const CardsDadosConsultoria: React.FC<CardsDadosConsultoriaProps> = ({ dados_consultoria, buscar_consultoria, abrir_gaveta, modulos }) => {
    const dadosFiltrados = dados_consultoria?.filter((item) => item?.usuario_nome?.toLowerCase().includes(buscar_consultoria?.toLowerCase()));

    return (
        <ContainerCards>
            {dadosFiltrados?.length > 0 ? dadosFiltrados.map((item) => (
                <Card key={item.cod}>
                    <div className="header__card">
                        <div className="icone__perfil">
                            <div className="icone">{(item?.usuario_nome || 'US').substring(0, 2).toUpperCase()}</div>
                            <div className="nome__perfil">
                                <h3>{item?.usuario_nome}</h3>
                                <span>{item?.perfil?.nome}</span>
                            </div>
                        </div>
                        <div className="acoes__card">
                            <ButtonCustom type="secondary" onClick={() => abrir_gaveta(item?.cod_func)} icon={<FontAwesomeIcon icon={faEye} />} />
                        </div>
                    </div>

                    <LineDivider marginTop={5} />

                    <ContainerTags>
                        {(() => {
                            if (!item?.perfil?.permissoes) return null;
                            const modulosUnicos = new Map();
                            item?.perfil?.permissoes?.forEach((permissao: any) => {
                                const modulo = modulos?.find((m) => m?.cod === permissao?.cod_modulo_rotina);
                                if (modulo?.nome) {
                                    modulosUnicos.set(modulo.nome, modulo.nome);
                                }
                            });
                            return Array.from(modulosUnicos.values()).map((nomeModulo: string, index: number) => (
                                <Tag key={index} color={corDoModulo(nomeModulo)} style={{ padding: '3px 10px', fontWeight: 'bold', width: 'fit-content' }}>
                                    {nomeModulo}
                                </Tag>
                            ));
                        })()}
                    </ContainerTags>
                </Card>
            )) : (
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px 0', color: '#999' }}>
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                            <>
                                {' '}
                                <b>'{buscar_consultoria}'</b> não encontrado!
                            </>
                        }
                    />
                </div>
            )}
        </ContainerCards>
    )
}